import { useEffect, useState } from "react";
import { resetPassword } from "../services/config";

const ResetPassword = () => {
  const [data, setData] = useState<string>();

  useEffect(() => {
    (async () => {
      const res = await resetPassword(window.location.search.split('=')[1]);
      setData(res);
    })();
  }, []);

  return <div>
    {!!data && <div>{data}</div>}
  </div>;
};

export default ResetPassword;